module.exports = __webpack_public_path__ + "static/media/footer-logo.71cb7da0.svg";